import React from 'react';
import { Field } from 'react-final-form';

import { InputText } from '../UI';

/**
 * @description Honeypot component that will be filled by robots, if field is filled, we must not send to API
 * @type {React.FC<undefined>}
 */
const HoneyPot = () => (
  <Field name="comments" subscription={{}}>
    {({ input }) => <InputText {...input} className="comments-name" />}
  </Field>
);

export default HoneyPot;
